export const DEACTIVATED_ACCOUNT_MESSAGE =
  "Your account is deactivated. Please contact the Super Admin.";

const STORAGE_KEY = "deactivatedAccountMessage";

export function isDeactivatedResponse(status, message) {
  return (
    Number(status) === 403 &&
    String(message || "")
      .toLowerCase()
      .includes("deactiv")
  );
}

/** Clear session and redirect to login when a logged-in admin was deactivated. */
export function handleDeactivatedAccount(message) {
  if (!localStorage.getItem("accessToken")) {
    return false;
  }

  sessionStorage.setItem(
    STORAGE_KEY,
    message || DEACTIVATED_ACCOUNT_MESSAGE
  );
  localStorage.removeItem("accessToken");
  localStorage.removeItem("2xgxgshdugyywerw12eccom");
  localStorage.removeItem("2xgxgshdugyywerw12gh");

  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
  return true;
}

export function consumeDeactivatedAccountMessage() {
  const message = sessionStorage.getItem(STORAGE_KEY);
  if (message) {
    sessionStorage.removeItem(STORAGE_KEY);
  }
  return message;
}

async function inspectResponse(response) {
  if (!localStorage.getItem("accessToken") || response.status !== 403) {
    return;
  }

  try {
    const data = await response.clone().json();
    if (isDeactivatedResponse(response.status, data?.message)) {
      handleDeactivatedAccount(data.message);
    }
  } catch {
    // ignore non-JSON bodies
  }
}

let fetchGuardInstalled = false;

/** Intercept fetch + axios 403 responses for deactivated accounts. */
export function installDeactivatedAccountGuard() {
  if (fetchGuardInstalled || typeof window === "undefined") {
    return;
  }
  fetchGuardInstalled = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (...args) =>
    (async () => {
      try {
        const response = await originalFetch(...args);
        await inspectResponse(response);
        return response;
      } catch (err) {
        throw err;
      }
    })();
}
